import { useActingAsUserId, useRound } from "@client/pages/round/round-context";
import { isRestrictedFunderViewer } from "@engine/round/accessors";

/**
 * Whether the current viewer is a restricted funder of the round — used to
 * gate client surfaces (nav, routing, Decide-surface query gating). Keyed to
 * the **acting-as** user (`actingAsUserId` from the round state context),
 * mirroring `useRoundAdmin` in `ImpersonateContext.tsx` so admin View-As
 * previews render exactly what the restricted funder would see.
 *
 * Returns false when the round hasn't loaded yet.
 */
export function useIsRestrictedFunder(): boolean {
  const round = useRound();
  const actingAsUserId = useActingAsUserId();

  if (round == null || actingAsUserId == null) {
    return false;
  }

  return isRestrictedFunderViewer(round, actingAsUserId);
}
